import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  button: {
    float: 'right',
    padding: 0,

    '&:hover': {
      background: 'none',
    },
  },
}));
